import { FunctionComponent } from 'react'
import useStyles from './styles'
import { Icon } from '@conexasaude/iconography/icons'

import {
  getDateInFull,
  getDayPeriod,
  getTimeInHourAndMinute,
} from '@/utils/date'
import { capitalize } from '@/utils/fnUtils'
import { getCache } from '@/utils/cache'

import { useAuthContext } from '@/modules/Auth/contexts/AuthContext'
import { IMMEDIATE_ATTENDANCE } from '@/modules/Attendance/constants'
import { RenderIf } from '@/components/RenderIf'
import { Tag, getTheme, Text } from '@conexasaude/conexa-hero'
import { ConfirmationReservationDetailsProps } from './types'
import { MINIMUM_HOURS_TO_CANCEL_OR_RESCHEDULE_PSYCHOLOGIST } from '@/constants'
import { useCheckoutStore } from '@/modules/Checkout/stores/checkout.store'

const ConfirmationReservationDetails: FunctionComponent<
  ConfirmationReservationDetailsProps
> = ({ date, council }) => {
  const styles = useStyles()
  const attendanceType = getCache('attendanceType')
  const { clinic } = useAuthContext()
  const card = useCheckoutStore(state => state.card)
  const dateInFull = getDateInFull(date, {
    reversed: true,
  })
  const dayPeriod = getDayPeriod(date)
  const timeInHourAndMinute = getTimeInHourAndMinute(date)

  const theme = getTheme()

  return (
    <div>
      <div>
        <div css={styles.wrapperTag}>
          <Tag variant="primary">Horário reservado</Tag>
        </div>
        <div css={styles.containerData}>
          <Icon name="calendar" size={21} color={theme.colors.neutral[300]} />
          <Text>{dateInFull}</Text>
        </div>
        <div css={styles.containerData}>
          <Icon name="clock" size={21} color={theme.colors.neutral[300]} />
          <Text>
            {timeInHourAndMinute} da {dayPeriod}
          </Text>
        </div>
        <RenderIf condition={!!card && clinic?.canPrivateAttendance}>
          <div css={styles.containerData}>
            <Icon
              name="credit-card"
              size={21}
              color={theme.colors.neutral[300]}
            />
            <Text>
              Cartão de {card?.type === 'CREDIT' ? 'Crédito' : 'Débito'}: ****{' '}
              {card?.finalCardNumbers} (
              {card ? capitalize(card?.flag?.toLowerCase()) : ''})
            </Text>
          </div>
        </RenderIf>

        <RenderIf
          condition={
            council !== 'PSICOLOGO' &&
            clinic?.minimumHoursToCancel > 0 &&
            attendanceType !== IMMEDIATE_ATTENDANCE
          }
        >
          <Text>
            Você pode reagendar ou cancelar a consulta com até{' '}
            {clinic?.minimumHoursToCancel}h de antecedência.
          </Text>
        </RenderIf>
        <RenderIf
          condition={
            council === 'PSICOLOGO' && attendanceType !== IMMEDIATE_ATTENDANCE
          }
        >
          <Text>
            Você pode reagendar ou cancelar a consulta com até{' '}
            {MINIMUM_HOURS_TO_CANCEL_OR_RESCHEDULE_PSYCHOLOGIST}h de
            antecedência.
          </Text>
        </RenderIf>
      </div>
    </div>
  )
}

export default ConfirmationReservationDetails
